import client from "./client";

export async function createApplePaySession() {
    const response = await client.get("/cart/apple-pay");

    return response.data;
}

export async function placeApplePayOrder(inputs: Record<string, unknown>) {
    const response = await client.post("/checkout/apple-pay", inputs);

    return response.data;
}

export async function setupPaypalCheckout(payload: Record<string, unknown>) {
    const response = await client.post("/checkout/paypal", payload);

    return response.data;
}

export async function getPaypalNonce() {
    const response = await client.get("/cart/paypal");

    return response.data;
}

export async function deletePaypalNonce() {
    const response = await client.delete("/cart/paypal");

    return response.data;
}

export async function completeShippingAddress(inputs: Record<string, unknown>) {
    const response = await client.post("/checkout/success/update", inputs);

    return response.data;
}
